import React from 'react';

export function ExportModal({ isOpen, onClose, exportYear, onYearChange, onExport, exporting }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-surface border border-border rounded-xl p-6 max-w-md w-full">
        <h2 className="text-2xl font-serif font-bold text-foreground mb-4">
          Export Tax Report
        </h2>
        
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-foreground mb-1.5">
              Tax Year
            </label>
            <select
              value={exportYear}
              onChange={(e) => onYearChange(parseInt(e.target.value))}
              className="w-full bg-surface-raised border border-border rounded-lg px-4 py-2 text-foreground focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all"
              data-testid="export-year-select"
            >
              {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>
          
          <div className="bg-primary/10 border border-primary/30 rounded-lg p-3 text-sm text-text-secondary">
            This will export all tax-deductible expenses for the selected year.
          </div>
          
          <div className="flex gap-3 pt-2">
            <button
              onClick={onClose}
              disabled={exporting}
              className="flex-1 bg-secondary text-foreground hover:bg-secondary/80 border border-border rounded-lg px-4 py-2 font-medium transition-colors disabled:opacity-50"
              data-testid="export-cancel-button"
            >
              Cancel
            </button>
            <button
              onClick={() => onExport('csv')}
              disabled={exporting}
              className="flex-1 bg-surface-raised text-foreground hover:bg-surface-raised/80 border border-border rounded-lg px-4 py-2 font-medium transition-colors disabled:opacity-50"
              data-testid="export-csv-button"
            >
              {exporting ? 'Exporting...' : 'CSV'}
            </button>
            <button
              onClick={() => onExport('pdf')}
              disabled={exporting}
              className="flex-1 bg-primary text-background hover:bg-primary/90 rounded-lg px-4 py-2 font-medium transition-colors disabled:opacity-50"
              data-testid="export-pdf-button"
            >
              {exporting ? 'Exporting...' : 'PDF'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
